import { render, staticRenderFns } from "./BtnObterDadosRM.vue?vue&type=template&id=7b20a62c"
import script from "./BtnObterDadosRM.vue?vue&type=script&lang=js"
export * from "./BtnObterDadosRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports